import { render, staticRenderFns } from "./CategoryHeader.vue?vue&type=template&id=30664638&scoped=true&"
import script from "./CategoryHeader.vue?vue&type=script&lang=js&"
export * from "./CategoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./CategoryHeader.vue?vue&type=style&index=0&id=30664638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30664638",
  null
  
)

export default component.exports